export default __webpack_public_path__ + "static/assets/3f849ea282961c9b83ebbfd088937cf3.png";